import CryptoJS from 'crypto-js'
import { useLocalStorage, useSessionStorage, useStorage } from '@/hooks/web/useStorage'
import useApi from '@/api/live'
import { _isMobile, getBrowser, getSystem, isJSON } from './is'

const { getStorage } = useStorage()
const localStorage = useLocalStorage()
const sessionStorage = useSessionStorage()

// DES解密
const decryptDes = (message: string, key: string) => {
  console.log('解密', key, message)
  try {
    const keyHex = CryptoJS.enc.Utf8.parse(key)
    const decrypted = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Hex.parse(message)
      },
      keyHex,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    )
    const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8)
    // 新增：验证填充是否有效
    if (!isValidPadding(decryptedStr)) {
      return ''
    }
    return decryptedStr
  } catch (error) {
    console.error(`参数解析错误: ${message}`, error)
    return ''
  }
}

// 验证PKCS#7填充有效性
const isValidPadding = str => {
  if (!str) return false

  // 获取最后一个字符的ASCII码
  const lastChar = str.charCodeAt(str.length - 1)

  // PKCS#7填充值应在1-8范围内
  if (lastChar < 0x01 || lastChar > 0x08) return true

  // 验证填充一致性
  for (let i = 1; i <= lastChar; i++) {
    if (str.charCodeAt(str.length - i) !== lastChar) {
      return false
    }
  }
  return true
}

// DES加密
const encryptedDes = (message: string, key: string) => {
  console.log('加密', key, message)

  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const encrypted = CryptoJS.DES.encrypt(message, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

/** 遍历解密参数 */
const setSignCode = (msg: any) => {
  const strJson = <any>{}
  const data = decryptDes(msg, 'riceLive')

  if (data) {
    data.split('&').map((item: string) => {
      const keyValueArr = item.split('=') // 再次按照"="进行切割得到key和value
      const key = <any>keyValueArr[0]
      strJson[key] = keyValueArr[1]
    })
  }
  return strJson
}

/**
 * 获取登录信息
 * @param type 要获取的登录信息字段
 * @param str 登录信息存储的辅助字段
 * @returns
 */
const getLoginInfo = (type: string, str: string = 'roomId') => {
  const info = useStorage('localStorage').getStorage(`loginInfo_${getStorage(str)}`) ?? {}
  if (type === 'all') {
    return info || {}
  }
  return info[type]
}

/**
 * 移除登录信息
 */
const removeLoginInfo = () => {
  const roomId = sessionStorage.get('roomId')
  localStorage.remove(`loginInfo_${roomId}`)
}

const setLoginInfo = (data: any, type: string = 'roomId') => {
  const roomId = sessionStorage.get(type)
  localStorage.set(`loginInfo_${roomId}`, { ...getLoginInfo('all'), ...data })
}

// 并发处理
const randomOut = () => {
  return new Promise(r => {
    const num = Math.round(Math.random() * 3 + 1)
    setTimeout(() => {
      r('success')
    }, num * 1000)
  })
}

// 防抖处理
const clickList: any = []
const clicking = (type: string, val: string) => {
  return new Promise(r => {
    switch (type) {
      case 'add':
        clickList.push(val)
        r(true)
        break
      case 'del': {
        const i = clickList.findIndex((item: string) => item === val)
        clickList.splice(i, 1)
        r(true)
        break
      }
      case 'get':
        r(clickList.includes(val) ? false : true)
        break
      default:
        break
    }
  })
}

// 需求埋点

// 观看端数据埋点
// 进入直播间时埋点
const enterPoint = (val: any) => {
  try {
    const params = {
      eventName: 0,
      studentId: getLoginInfo('userId'),
      studentName: getLoginInfo('name'),
      // sessionId: "Group" + val.groupId + "_" + getStorage('liveRecordId'),
      liveRecordId: getStorage('liveRecordId'),
      roomId: getStorage('roomId'),
      roomName: val.roomName,
      clientId: getStorage('clientId'),
      pageUrl: window.location.href.replace(_isMobile() ? '/mobile' : '/live', ''),
      entryMethod: 1,
      liveState: val.liveStatus,
      browser: getBrowser(),
      browserType: _isMobile() ? 'H5' : 'PC',
      studentType: 0,
      entryTime: new Date().getTime(),
      channelId: getStorage('accountId') || '',
      channelName: getStorage('channelName') || '',
      pushType: val.pushType,
      pushChannel: val.pushChannel,
      viewType: val.viewType,
      videoType: getStorage('videoType') || '',
      openId: getLoginInfo('openId') || '',
      unionId: getLoginInfo('unionId') || '',
      isNew: getLoginInfo('isNew') || '',
      studentStatueChange: useStorage('localStorage').getStorage('studentStatueChange'),
      playbackVideoId: val.playbackVideoId,
      osType: getSystem()
    }
    useApi.createEnter(params)
  } catch (error) {
    console.log('pointError: createEnter', error)
  }
}

// 发送弹幕行为埋点
const createSend = (val: any) => {
  try {
    const params = {
      eventName: 2,
      studentId: getLoginInfo('userId'),
      studentName: getLoginInfo('name'),
      // sessionId: "Group" + val.groupId + "_" + getStorage('liveRecordId'),
      liveRecordId: getStorage('liveRecordId'),
      roomId: getStorage('roomId'),
      roomName: val.roomName,
      clientId: getStorage('clientId'),
      pageUrl: window.location.href.replace(_isMobile() ? '/mobile' : '/live', ''),
      entryMethod: 1,
      liveState: val.liveStatus,
      browser: getBrowser(),
      browserType: _isMobile() ? 'H5' : 'PC',
      studentType: 0,
      messageContent: val.str,
      messageType: val.msgType === 1 ? 0 : 1,
      channelId: getStorage('accountId') || '',
      channelName: getStorage('channelName') || '',
      videoType: getStorage('videoType') || '',
      openId: getLoginInfo('openId') || '',
      unionId: getLoginInfo('unionId') || '',
      isNew: getLoginInfo('isNew') || '',
      studentStatueChange: useStorage('localStorage').getStorage('studentStatueChange'),
      osType: getSystem(),
      viewType: val.viewType
    }
    useApi.createSend(params)
  } catch (error) {
    console.log('pointError: createSend', error)
  }
}

// 点击行为埋点
const createClick = (val: any) => {
  try {
    const params = {
      eventName: 3,
      studentId: getLoginInfo('userId'),
      studentName: getLoginInfo('name'),
      // sessionId: "Group" + val.groupId + "_" + getStorage('liveRecordId'),
      liveRecordId: getStorage('liveRecordId'),
      roomId: getStorage('roomId'),
      roomName: val.roomName,
      clientId: getStorage('clientId'),
      pageUrl: window.location.href.replace(_isMobile() ? '/mobile' : '/live', ''),
      browser: getBrowser(),
      browserType: _isMobile() ? 'H5' : 'PC',
      studentType: 0,
      productId: val.id,
      productName: val.name,
      channelId: getStorage('accountId') || '',
      channelName: getStorage('channelName') || '',
      videoType: getStorage('videoType') || '',
      openId: getLoginInfo('openId') || '',
      unionId: getLoginInfo('unionId') || '',
      isNew: getLoginInfo('isNew') || '',
      studentStatueChange: useStorage('localStorage').getStorage('studentStatueChange'),
      osType: getSystem(),
      viewType: val.viewType
    }
    useApi.createClick(params)
  } catch (error) {
    console.log('pointError: createClick', error)
  }
}

// 停留时长埋点
const createStay = (val: any) => {
  try {
    const params = {
      eventName: 4,
      studentId: getLoginInfo('userId'),
      studentName: getLoginInfo('name'),
      // sessionId: "Group" + val.groupId + "_" + getStorage('liveRecordId'),
      liveRecordId: getStorage('liveRecordId'),
      roomId: getStorage('roomId'),
      roomName: val.roomName,
      clientId: getStorage('clientId'),
      pageUrl: window.location.href.replace(_isMobile() ? '/mobile' : '/live', ''),
      entryMethod: 1,
      browser: getBrowser(),
      browserType: _isMobile() ? 'H5' : 'PC',
      studentType: 0,
      startTime: val.startTime,
      endTime: new Date().getTime(),
      stayTimes: val.stayTimes,
      channelId: getStorage('accountId') || '',
      channelName: getStorage('channelName') || '',
      viewType: val.viewType,
      videoType: getStorage('videoType') || '',
      openId: getLoginInfo('openId') || '',
      unionId: getLoginInfo('unionId') || '',
      isNew: getLoginInfo('isNew') || '',
      studentStatueChange: useStorage('localStorage').getStorage('studentStatueChange'),
      pushType: val.pushType,
      pushChannel: val.pushChannel,
      playbackVideoId: val.playbackVideoId,
      osType: getSystem()
    }
    useApi.createStay(params)
  } catch (error) {
    console.log('pointError: createStay', error)
  }
}
/**
 * 获取红包领取信息 房间roomId＋用户id
 * @param type redReceiveList 要获取的登录信息字段
 * @param str roomId登录信息存储的辅助字段
 * @returns
 */
const getRedReceiveInfo = (type: string = 'redReceiveList', str: string = 'roomId') => {
  const userId = getLoginInfo('userId')
  const info = useStorage('localStorage').getStorage(`redReceive_${getStorage(str)}_${userId}`) ?? {}
  return info[type]
}

/** 重构历史消息结构 */
const historyMsgChange = (params: any) => {
  const obj: any = {}
  obj.type = params.msgType
  // 文本消息处理
  if (params.msgType === 'TIMTextElem') {
    obj.payload = { text: JSON.parse(params.message).Text, description: '' }
  } else if (params.msgType === 'TIMCustomElem') {
    // 系统消息
    if (params?.notifyType === 44) {
      return null
    } else if (params.notifyType === 20) {
      const msg = JSON.parse(params.message)
      obj.payload = { data: JSON.stringify(JSON.parse(msg.Data)) }
      obj.type = 'TIMGroupSystemNoticeElem'
    } else if ([3, 4, 5, 6, 21, 22].includes(params.notifyType)) {
      return false
    } else if (params.notifyType === 45) {
      // 渠道消息处理
      const dataStr = JSON.parse(params.message)?.Data
      if (!dataStr) {
        return false
      }
      const data = JSON.parse(dataStr)
      if (!data) {
        return false
      }
      const accountId = getStorage('accountId')
      let isSend = false

      if (data.channelType === 0) {
        if (data.channelIds.includes(accountId)) {
          isSend = true
        }
      } else if ([1, 2].includes(data.channelType)) {
        if (data.channelIds.includes(accountId) || !accountId) {
          isSend = true
        }
      }

      if (isSend) {
        if (data.messageType === 1) {
          obj.payload = { text: data.content, description: '' }
          obj.type = 'TIMTextElem'
        } else if (data.messageType === 2) {
          obj.payload = {
            data: JSON.stringify({ img: data.imgUrl, notifyType: 23 }),
            description: 'IMAGE_MESSAGE'
          }
        }
      } else {
        return false
      }
    } else if ([-1].includes(params.notifyType)) {
      const { Ext } = JSON.parse(params.message)
      const val = JSON.parse(Ext)
      if (val?.msgType == 'AUDIENCE_NOREAD' && val?.userId != userID.value) {
        return false
      } else {
        obj.payload = {
          data: JSON.parse(params.message)?.Data,
          description: JSON.parse(params.message)?.Desc,
          extension: JSON.parse(params.message)?.Ext
        }
      }
    } else {
      obj.payload = {
        data: JSON.parse(params.message)?.Data,
        description: JSON.parse(params.message)?.Desc,
        extension: JSON.parse(params.message)?.Ext
      }
    }
  }
  obj.nick = params.liveUsername
  obj.clientTime = params.msgTime
  obj.from = params.liveUserId
  obj.history = true
  return { ...params, ...obj }
}

/** 解析消息中的用户信息 */
const getMsgInfo = (params: any) => {
  if (params && params.cloudCustomData && isJSON(params.cloudCustomData)) {
    const { messageInfo, userInfo } = JSON.parse(params.cloudCustomData || null)
    return {
      ...messageInfo,
      ...userInfo
    }
  } else {
    return {}
  }
}

export {
  decryptDes,
  getLoginInfo,
  removeLoginInfo,
  setLoginInfo,
  randomOut,
  clicking,
  createSend,
  enterPoint,
  createClick,
  createStay,
  encryptedDes,
  getRedReceiveInfo,
  historyMsgChange,
  getMsgInfo,
  setSignCode
}
